export default "__VITE_ASSET__iId7BdEU__"